import * as React from "react";

import "./styles.scss";

export interface ICheckboxProps {
  title: string;
  name?: string;
  className?: string;
  disabled?: boolean;
  checked?: boolean;
  onChange?: (e: any) => void;
  onFocus?: () => void;
  onBlur?: () => void;
}

class Checkbox extends React.PureComponent<ICheckboxProps> {
  render() {
    return (
      <div className={this.props.className}>
        <label className="checkbox">
          <input
            name={this.props.name}
            className="checkbox__input"
            type="checkbox"
            checked={this.props.checked}
            disabled={this.props.disabled}
            onChange={this.props.onChange}
            onFocus={this.props.onFocus}
            onBlur={this.props.onBlur}
          />
          <span className="checkbox__label">
            {this.props.title || this.props.children}
          </span>
        </label>
      </div>
    );
  }
}

export default Checkbox;
